import React from 'react'
import styles from './style.module.scss'

const ImageProfile : React.FC = () => {
    return (
        <div className={styles.ImageProfileContainer}>
            <div className={styles.ImageProfile}></div>
        </div>
    )
}

export default ImageProfile